<div *ngIf="show" class="loader-spinner-container">
  <div class="loader-spinner-inner"></div>
</div>
